<template>
    <div
        class="form-item"
        :class="{ '-has-errors': hasError, '-input-hidden': hasSpoiler && inputHidden, '-has-spoiler': hasSpoiler }"
    >
        <slot name="label">
            <label v-if="!noLabel && labelFormated" @click="handleSpoiler" :for="name" class="form-item__label">
                {{ labelFormated
                }}<span class="material-icons-outlined spoiler-icon" v-if="hasSpoiler">{{
                    inputHidden ? 'expand_more' : 'expand_less'
                }}</span></label
            >
        </slot>
        <slot></slot>
        <div v-if="hasError" class="form-item__error">
            <ul class="form-item__error-list">
                <li v-for="(error, index) in errors" :key="index">{{ $t(error) }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormItem',
    // inheritAttrs: false,
    props: {
        errors: { type: [Array, Object], default: () => [] },
        label: { type: String, default: '' },
        name: { type: String, default: '' },
        noLabel: { type: Boolean, default: false },
        hasSpoiler: { type: Boolean, default: false },
        rules: { type: Array, default: () => [] },
    },
    data() {
        return {
            inputHidden: true,
        };
    },
    methods: {
        handleSpoiler() {
            if (this.hasSpoiler) {
                this.inputHidden = !this.inputHidden;
            }
        },
    },
    computed: {
        labelFormated: function () {
            const label = this.label ? this.label : this.name;
            const isNoEmpty = this.rules ? this.rules.includes('noEmpty') : false;
            return isNoEmpty ? `${label}*` : label;
        },
        hasError: function () {
            return Array.isArray(this.errors) && this.errors.length > 0;
        },
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.form-item {
    display: block;
    position: relative;
    margin-bottom: 20px;

    &.-has-errors {
        input {
            // border-color: $error;
        }
    }
    &.-has-spoiler {
        max-height: 500px;
        transition: max-height 0.5s;
        overflow: hidden;
        .form-item__label {
            cursor: pointer;
        }
        &.-input-hidden {
            max-height: 25px;
            transition: max-height 0.2s;
        }
    }
    &__label {
        display: inline-block;
        font-size: 14px;
        line-height: 16px;
        color: $text;
    }

    &__conteiner {
        position: relative;
    }

    &__field {
        display: block;
        width: 100%;
        border: 1px solid transparent;
        // border: 1px solid $outline;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 1rem;
        color: $text;
        font-size: 14px;
        line-height: 24px;
        background: #f5f6f6;

        &:focus {
            border-color: $primary !important;
            caret-color: $primary !important;
        }
        &:hover {
            border-color: $text-secondary;
        }
        &::placeholder {
            font-size: 14px;
            color: $text-secondary;
        }
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        [type='number'] {
            -moz-appearance: textfield;
        }
    }
    &__label + &__field {
        margin-top: 0.25rem;
    }
    &__label + &__checkbox {
        float: left;
    }

    &__error {
        display: block;
        font-size: 12px;
        line-height: 1.5rem;
        margin: 8px 0 0;
        color: $error;

        ul {
            padding: 0;
            list-style: none;
        }

        li {
            margin: 0;
            padding: 0;
        }
    }

    .spoiler-icon {
        font-size: 20px;
        position: relative;
        top: 4px;
        margin-left: 3px;
    }
}
</style>
